import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { ContentItemPostiesSecondary } from "scmp-app/components/content/content-item-render/variants/posties-secondary";
import { Headline } from "scmp-app/components/posties/content-homepage/headline";
import {
  OvalBottomBackground,
  OvalUpperBackground,
} from "scmp-app/components/posties/content-homepage/oval-background";

import Divider from "./divider.svg?url";
import EarthLeft from "./earth-left.svg?url";
import EarthRight from "./earth-right.svg?url";

export const Container = styled.div`
  position: relative;

  background: #8ad1ef;

  &::before,
  &:after {
    position: absolute;
    inset-block-start: 0;
    content: "";
    z-index: 0;

    background-repeat: no-repeat;
    background-size: cover;
  }

  &::before {
    inset-inline-start: 0;

    ${props => props.theme.breakpoints.up("tablet")} {
      inline-size: 294px;

      background-image: url(${EarthLeft});
      background-position: right center;
      aspect-ratio: 294 / 1941;
    }

    ${props => props.theme.breakpoints.up("desktop")} {
      inline-size: 421px;
      aspect-ratio: 421 / 1941;
    }
    ${props => props.theme.breakpoints.up("largeDesktop")} {
      aspect-ratio: 608 / 1941;

      inline-size: 608px;
    }
  }

  &::after {
    inset-inline-end: 0;

    ${props => props.theme.breakpoints.up("desktop")} {
      inline-size: 49px;

      background-image: url(${EarthRight});
      background-position: left center;
      aspect-ratio: 49 / 1896;
    }

    ${props => props.theme.breakpoints.up("desktop")} {
      aspect-ratio: 181 / 1896;

      inline-size: 181px;
    }
    ${props => props.theme.breakpoints.up("largeDesktop")} {
      aspect-ratio: 387 / 1896;

      inline-size: 387px;
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 2;

  margin-inline: auto;
  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 922px;
    padding-inline: 72px;
  }
`;

const backgroundStyle = css`
  position: relative;
  z-index: 2;

  overflow: hidden;
`;

export const StyledOvalUpperBackground = styled(OvalUpperBackground)`
  ${backgroundStyle}
  position: absolute;
  inset-inline-start: 0;
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    position: relative;
    inset-block-start: 0;
  }
`;

export const StyledOvalBottomBackground = styled(OvalBottomBackground)`
  ${backgroundStyle}
`;

export const StyledHeadline = styled(Headline)`
  margin-block-end: 24px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 64px;
  }
`;

export const StyledContentItemPostiesSecondary = styled(ContentItemPostiesSecondary)`
  position: relative;

  &:nth-child(even) > * {
    ${props => props.theme.breakpoints.up("tablet")} {
      grid: "content cover" min-content/1fr 320px;
    }
  }

  &:not(:last-child) {
    padding-block-end: 60px;
    &::after {
      position: absolute;
      inset-block-end: 0;
      content: "";

      inline-size: 100%;
      block-size: 12px;
      margin-block: 24px;

      background-image: url(${Divider});
      background-position: center;
    }
  }
`;

export const EyeOnTheNewsItems = styled.div`
  max-inline-size: 270px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 778px;
  }
`;
